<script setup>
import { ref, onMounted, watch, defineExpose, reactive, defineEmits } from "vue"
// import i18n from "@/i18n"
import { dateFormat1 } from "@/utils/common.js";
// import { useRouter } from "vue-router";
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import Swal from "sweetalert2";
import { get_my_supply_chain_v3, delete_my_supply_chain_v3, put_my_supply_chain_status_v3 } from "@/service/apiList/supplyChain"
import { getLangValue } from "@/utils/common"; //获取后端语言
const emits = defineEmits(['onShowDetail'])
const tableInfo = ref([])
// const router = useRouter()
const loading = ref(false)
const table_head = ref([
    { label: getLangValue("my.supply-chain","tableHeader1"), width: '10%', },
    { label: getLangValue('my.supply-chain','placeholder2'), width: '10%', },
    { label: getLangValue("attribute.description"), width: '10%', },
    { label: getLangValue("my.account","form_contacts"), width: '10%', },
    { label: getLangValue("attribute.mobile"), width: '10%', },
    { label: getLangValue("attribute.email"), width: '10%', },
    { label: getLangValue("my.supply-chain","tableHeader2"), width: '10%', },
    { label: getLangValue("my.supply-chain","tableHeader3"), width: '10%', sortable: false },
    { label: getLangValue("base.operation"), width: '10%', },
])
const pageSizeOption = [10, 20, 30, 40, 50]

const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const { alertInfo, openAlert, formValidataAlert } = useMessage()

const searchInfo = reactive({
    type: '', //类型
    keyword: '',
    date: null,
    order_by: 'desc'
})
const handler = (type, info) => {
    //按钮处理
    switch (type) {
        case 'view':
            // 根据状态显示信息   未审批直接到审批页面    未通过  已通过到详情页面
            emits('onShowDetail', { type: type, info: info })
            break;
        case 'edit':
            emits('onShowDetail', { type: type, info: info })
            break;
        case 'delete':
            deleteData(info)
            break;
    }
}

const switchChange = async ({ id, enabled }) => {
    //切换开关
    let params = {
        disabled: enabled ? 0 : 1
    }
    const resp = await put_my_supply_chain_status_v3(id, params)
    if (resp) {
        openAlert({
            variant: resp.code == 1 ? "danger" : 'success',
            content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
        });
        getDataList();
    }
}

const deleteData = async (info) => {
    const { id } = info;
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // console.log(id)
            //延迟2s操作
            let resp = await delete_my_supply_chain_v3(id);
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                });
                //  更新
                getDataList();
            }
        }
    });
}

const getDataList = async () => {
    // let arr = searchInfo.date == null || !searchInfo.date ? [] : searchInfo.date.replaceAll(' ', '').split('to')
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        name: searchInfo.keyword,
        type: searchInfo.type, //类型
        on_time: searchInfo.date == null  || !searchInfo.date ? "" : JSON.stringify(searchInfo.date),
        order_by: searchInfo.order_by,
        sort_field: 'create_time',
    }
    // console.log(params);
    let xx = true
    if (xx) {
        loading.value = true
        const resp = await get_my_supply_chain_v3(params);
        loading.value = false
        if (resp.code == 0) {
            resp.payload.data.forEach(element => {
                element.enabled = !element.disabled
            });
            tableInfo.value = resp.payload.data;
            total.value = resp.payload.total;
        } else {
            openAlert({
                variant: "danger",
                content: resp.message,
            });
        }
    }
}


const sort = (type) => {
    searchInfo.order_by = type
}


watch(pageSize, () => {
    currentPage.value = 1;
    getDataList()
})


watch(currentPage, () => {
    getDataList();
})

watch(searchInfo, () => {
    currentPage.value = 1;
    getDataList();
}, { deep: true })


onMounted(() => {
    getDataList()
})
//弹出
defineExpose({
    searchInfo,
    getDataList,
})
</script>

<template>
    <div class="form px-0" v-if="tableInfo.length || loading" style="height: calc(100% - 170px);">
        <!-- Bordered Tables -->
        <div class="my-scroll-bar" style="height:calc(100% - 50px ); overflow-y: auto;">
            <table class="table table-bordered table-nowrap mb-0" v-loading="loading">
                <thead class="table-light ">
                    <tr>
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #9599AD;"
                            :width="head.width">
                            <div class="d-flex align-items-center" style="height: 36px;">
                                {{ head.label }}
                                <div class="mx-2" v-if="head.sortable">
                                    <div :class="searchInfo.order_by == 'asc' ? 'sortActive' : ''" style="height: 13px;"
                                        class="cursor-pointer" @click="sort('asc')">▲</div>
                                    <span :class="searchInfo.order_by == 'desc' ? 'sortActive' : ''"
                                        class="cursor-pointer" @click="sort('desc')">▼</span>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                        <td>{{
                            info.name }}</td>
                        <td>{{ info.type }}</td>
                        <td :title="info.description"
                            style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;max-width: 200px;">{{
                                info.description }} </td>
                        <td>{{ info.contact_person }}</td>
                        <td>{{ info.contact_phone }}</td>
                        <td>{{ info.email }}</td>
                        <td>{{ info.on_time ? dateFormat1(info.on_time) : '' }}</td>
                        <td>{{ info.off_time ? dateFormat1(info.off_time) : '' }}</td>
                        <td>
                            <ul class=" list-inline hstack gap-2 mb-0">
                                <li class="mx-2" v-permit="'my.supply-chain.modify'">
                                    <b-form-checkbox v-model="info.enabled" switch
                                        @change="switchChange(info)"></b-form-checkbox>
                                </li>
                                <li class="list-inline-item cursor" v-permit="'my.supply-chain.show'">
                                    <div class="text-primary d-inline-block" @click="handler('view', info)">
                                        <i class="fs-16 ri-eye-fill"></i>
                                    </div>
                                </li>
                                <li v-if="info.disabled" class="list-inline-item cursor" >
                                    <div class="text-primary d-inline-block" @click="handler('edit', info)" v-permit="'my.supply-chain.modify'">
                                        <i class="fs-16 ri-pencil-fill"></i>
                                    </div>
                                </li>
                                <!-- 删除 -->
                                <li v-if="info.disabled" class="list-inline-item" title="delete" >
                                    <div class="d-inline-block text-danger cursor" @click="handler('delete', info)" v-permit="'my.supply-chain.delete'">
                                        <i class="fs-16 ri-delete-bin-5-fill"></i>
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5" style="margin-top: 0 !important;">
        </Pagination>
    </div>
    <div style="height: calc(100% - 170px);" v-else class="d-flex align-items-center justify-content-center">
        <Empty  style="margin-top: 200px;"></Empty>
    </div>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
</template>
<style scoped>
.table-bordered> :not(caption)>*>* {
    border: unset;
}
.table-bordered td, .table-bordered th {
    padding: 0.25rem 0.6rem !important;
}
.sortActive {
    color: black;
}
</style>